<template>
  <div class="con_inner">
    <div class="con_1">
      <div class="txt_1">
        '<span>{{ data.boardTitle }}</span
        >' 에서 작성됨
      </div>
      <div class="txt_2" @click="fnMore(data)">
        <i class="i_reply_more"></i>
      </div>
    </div>
    <div class="con_2" @click="goDetail(data.boardId)">
      {{ data.contents }}
    </div>
    <div class="con_3">
      <div class="txt_wrap">
        <div class="txt_1">{{ data.createdAt | moment('from') }}</div>
        <div class="txt_2">{{ data.writer }}</div>
      </div>
      <div class="txt_3"><i class="i_list_like"></i>{{ data.likeCnt }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'component-community-list-answer-item',
  description: '커뮤니티 > 리스트 답글 아이템',
  props: {
    boardType: {
      type: String,
      default: 'KNOWHOW',
      description: 'KNOWHOW: 지식인, BOARD: 자유게시판',
    },
    data: Object,
  },
  data() {
    return {
      categories: {
        MOBILE: '휴대폰',
        INTERNET: '인터넷',
        MVNO: '알뜰폰',
        PLAN: '요금제',
        RENTAL: '렌탈',
        STORE: '매장',
      },
    };
  },
  methods: {
    fnMore(item) {
      this.$emit('more', 'COMME_MINE_EDIT', item);
    },
    goDetail(item) {
      this.$emit('goDetail', item);
    },
  },
};
</script>

<style></style>
